import { Card, CardContent } from "./ui/card";
import { Heart, MessageSquare, Star, Lightbulb, Search, Target, HandHeart } from "lucide-react";

const WhyChooseSection = () => {
  const benefits = [
    {
      icon: Heart,
      title: "100% Personalized",
      description: "Our Love Report is crafted from your exact birth details. It analyzes your zodiac, planets, and charts to reveal your unique love, nature, compatibility, and relationship patterns."
    },
    {
      icon: MessageSquare,
      title: "Plain And Easy Language",
      description: "Our Love Report makes astrology simple, offering clear guidance on love and relationships in easy-to-understand language."
    },
    {
      icon: Star,
      title: "Expert Guidance By Acharya Luvbhushan",
      description: "With years of expertise, Acharya LavBhushan provides accurate, insightful readings to guide your love life meaningfully."
    },
    {
      icon: Lightbulb,
      title: "Actionable Remedies & Advice",
      description: "Our Love Report gives clear guidance to overcome obstacles, improve relationships, and build a happier, more harmonious love life."
    },
    {
      icon: Search,
      title: "In-Depth Love Insights",
      description: "The Love Report covers your full love life—personality, compatibility, future predictions, and tailored guidance for your unique astrological chart—helping you handle relationships with clarity and confidence."
    },
    {
      icon: Target,
      title: "Clarity & Confidence in Your Love Life",
      description: "Whether single, committed, or facing challenges, our Love Report reveals your love future, highlights obstacles, and guides you toward your destined relationship."
    }
  ];

  return (
    <section className="py-12 lg:py-20 bg-background_lv">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold mb-4 lg:mb-6">
            Why Use Our <span className="text-love-pink">Love Report?</span>
          </h2>
          <p className="text-base lg:text-lg text-muted_lv-foreground max-w-4xl mx-auto">
            Our Love Report is not a generic horoscope—it's a highly in-depth, meaningful guide to your love life, designed under the expert supervision of 
            Astro Acharya Luvbhushan. Here's why you need to use our Love Report:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8 max-w-7xl mx-auto">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <Card key={index} className="group hover:shadow-lg transition-all duration-300 border-2 border-love-pink/10 hover:border-love-pink/20">
                <CardContent className="p-4 lg:p-6 text-center">
                  <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-4 lg:mb-6 bg-love-pink/10 rounded-full flex items-center justify-center group-hover:bg-love-pink/20 transition-colors">
                    <IconComponent className="w-6 h-6 lg:w-8 lg:h-8 text-love-pink" />
                  </div>
                  <h3 className="text-lg lg:text-xl font-bold mb-2 lg:mb-4 text-foreground_lv group-hover:text-love-pink transition-colors">
                    {benefit.title}
                  </h3>
                  <p className="text-muted_lv-foreground text-xs lg:text-sm leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;